import { render } from "./PortMap.vue?vue&type=template&id=2ff2d12c&scoped=true"
import script from "./PortMap.vue?vue&type=script&lang=js"
export * from "./PortMap.vue?vue&type=script&lang=js"

import "./PortMap.vue?vue&type=style&index=0&id=2ff2d12c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff2d12c"]])

export default __exports__